module.exports = __webpack_public_path__ + "img/logo-databasin.ee8c96e3869321a7eb457cec1e14d0cb.png";